export default "__VITE_ASSET__2c703ea1__"